import CityPageTemplate from "../city-template/CityPageTemplate";
import { annArborConfig } from "./data";

export default function AnnArborPage() {
  return <CityPageTemplate config={annArborConfig} />;
}